// extracted by mini-css-extract-plugin
export var footer = "footer-2Ex";
export var footer_container = "footer_container-3UW";
export var logo = "logo-2n4";
export var menu_container = "menu_container-Aby";
export var policy_links_container = "policy_links_container-2wP";
export var copyright_container = "copyright_container-3kH";
export var menus_container = "menus_container-1Zi";